export default __webpack_public_path__ + "static/media/checked.c947f130.svg";